<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';

export interface GrammarTabBarProps {
  justifyContent?: 'left' | 'center' | 'stretch';
  selectedValue?: string;
}

const props = withDefaults(defineProps<GrammarTabBarProps>(), {
  justifyContent: 'left',
  selectedValue: '',
});

const emit = defineEmits(['change']);
function onChange(event: TpgChangeEvent<string>) {
  emit('change', event);
}
</script>

<template>
  <tpg-tab-bar v-bind="props" style="--barsTabBarSizingMainHeight: 2.75rem" @tpg-change="onChange">
    <slot />
  </tpg-tab-bar>
</template>
